import React, { useState } from "react";
import "./quadrantPage.css";

const QuadrantPage = () => {
  const [activeQuadrant, setActiveQuadrant] = useState("Quadrant 1");

  const renderContent = () => {
    switch (activeQuadrant) {
      case "Quadrant 1":
        return (
          <div style={{ padding: "20px" }}>
            <label>Main Text</label>
            <br />
            <input
              type="text"
              placeholder="Find lawyer"
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Sub Text</label>
            <br />
            <input
              type="text"
              placeholder="Search for lawyer in required area of practice."
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Cover Photo</label>
            <br />
            <input
              type="file"
              accept="image/*"
              style={{
                marginTop: "10px",
              }}
            />
          </div>
        );
      case "Quadrant 2":
        return (
          <div style={{ padding: "20px" }}>
            <label>Main Text</label>
            <br />
            <input
              type="text"
              placeholder="Find lawyer"
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Sub Text</label>
            <br />
            <input
              type="text"
              placeholder="Search for lawyer in required area of practice."
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Cover Photo</label>
            <br />
            <input
              type="file"
              accept="image/*"
              style={{
                marginTop: "10px",
              }}
            />
          </div>
        );
      case "Quadrant 3":
        return (
          <div style={{ padding: "20px" }}>
            <label>Main Text</label>
            <br />
            <input
              type="text"
              placeholder="Find lawyer"
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Sub Text</label>
            <br />
            <input
              type="text"
              placeholder="Search for lawyer in required area of practice."
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Cover Photo</label>
            <br />
            <input
              type="file"
              accept="image/*"
              style={{
                marginTop: "10px",
              }}
            />
          </div>
        );
      case "Quadrant 4":
        return (
          <div style={{ padding: "20px" }}>
            <label>Main Text</label>
            <br />
            <input
              type="text"
              placeholder="Find lawyer"
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Sub Text</label>
            <br />
            <input
              type="text"
              placeholder="Search for lawyer in required area of practice."
              style={{
                width: "100%",
                marginBottom: "15px",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid lightgray",
              }}
            />
            <label>Cover Photo</label>
            <br />
            <input
              type="file"
              accept="image/*"
              style={{
                marginTop: "10px",
              }}
            />
          </div>
        );
      default:
        return <div>No content available</div>;
    }
  };

  return (
    <div style={{ display: "grid", gap: "20px", paddingLeft: "10%" }}>
      <div
        style={{
          border: "1px hidden blue",
          height: "70vh",
          width: "90%",
          borderRadius: "10px",
          backgroundColor: "#f8f9fa",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex" }}>
          {["Quadrant 1", "Quadrant 2", "Quadrant 3", "Quadrant 4"].map(
            (quadrant, index) => (
              <button
                key={index}
                onClick={() => setActiveQuadrant(quadrant)}
                style={{
                  width: "25%",
                  backgroundColor:
                    activeQuadrant === quadrant ? "darkblue" : "blue",
                  color: "white",
                  height: "35px",
                  border: "none",
                  borderTopLeftRadius: index === 0 ? "5px" : "0",
                  borderTopRightRadius: index === 3 ? "5px" : "0",
                  cursor: "pointer",
                }}
              >
                {quadrant}
              </button>
            )
          )}
        </div>
        {/* Content Rendering */}
        <div style={{ flexGrow: 1 }}>{renderContent()}</div>
      </div>

      {/* Buttons Section */}
      <div
        style={{
          width: "90%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          padding: "10px",
        }}
      >
        <button
          style={{
            backgroundColor: "#e0e0e0",
            color: "black",
            border: "1px solid lightgray",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            width: "20%",
          }}
          onClick={() => console.log("Reset Clicked")}
        >
          Reset
        </button>
        <button
          style={{
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            width: "20%",
          }}
          onClick={() => console.log("Save Clicked")}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default QuadrantPage;
